import { sanitizeRichTextHtml } from '../../utils/sanitizeHtml';
//SideBySideModal.tsx
import React from 'react'
import { Modal, Row, Col, Typography } from 'antd'

const { Title } = Typography

interface SideBySideModalProps {
  visible: boolean
  originalHTML: string
  translationHTML: string
  onClose: () => void
}

const SideBySideModal: React.FC<SideBySideModalProps> = ({
  visible,
  originalHTML,
  translationHTML,
  onClose,
}) => {
  return (
    <Modal
      title="Compare Original & Translation"
      visible={visible}
      onCancel={onClose}
      width={1000}
      footer={null}
    >
      <Row gutter={[24, 24]}>
        <Col span={12}>
          <Title level={5}>Original</Title>
          <div
            style={{
              border: '1px solid #f0f0f0',
              padding: 16,
              borderRadius: 4,
              minHeight: 300,
              backgroundColor: 'var(--surface-muted)',
            }}
            dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(originalHTML) }}
          />
        </Col>
        <Col span={12}>
          <Title level={5}>Translation</Title>
          <div
            style={{
              border: '1px solid #f0f0f0',
              padding: 16,
              borderRadius: 4,
              minHeight: 300,
              backgroundColor: 'var(--surface-muted)',
            }}
            dangerouslySetInnerHTML={{ __html: sanitizeRichTextHtml(translationHTML) }}
          />
        </Col>
      </Row>
    </Modal>
  )
}

export default SideBySideModal